var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVeterinarian(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "1025wlyrfa",
    d: "M0.877 0.7L5.743 0.7 5.743 5.555 0.877 5.555z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "dl42cybauc",
    d: "M0 0.642L4.866 0.642 4.866 5.498 0 5.498z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "njquoguobe",
    d: "M0.7 0.7L5.566 0.7 5.566 5.555 0.7 5.555z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "6n75757eeg",
    d: "M0.677 0.642L5.543 0.642 5.543 5.498 0.677 5.498z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D99EBA",
    d: "M4.375 13.43L8.2 8.66c.773-.965 1.927-1.519 3.165-1.519h.813c1.239 0 2.392.554 3.166 1.519l3.824 4.77c.573.713.888 1.61.888 2.526 0 2.23-1.818 4.044-4.054 4.044H7.541c-2.236 0-4.054-1.814-4.054-4.044 0-.915.316-1.812.888-2.526"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.5 .2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "f5dzyfdqsb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#1025wlyrfa"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F4333F",
    d: "M5.743 3.128c0 1.34-1.089 2.427-2.433 2.427-1.343 0-2.433-1.086-2.433-2.427S1.967.699 3.31.699c1.344 0 2.433 1.088 2.433 2.429",
    mask: "url(#f5dzyfdqsb)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 6.5)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "95k0dnddpd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dl42cybauc"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F4333F",
    d: "M4.866 3.07c0 1.34-1.089 2.428-2.433 2.428C1.09 5.498 0 4.41 0 3.069 0 1.73 1.09.642 2.433.642c1.344 0 2.433 1.086 2.433 2.427",
    mask: "url(#95k0dnddpd)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.6 .2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b1pi9uv6zf",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#njquoguobe"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F4333F",
    d: "M.7 3.128c0 1.34 1.089 2.427 2.433 2.427 1.343 0 2.433-1.086 2.433-2.427S4.476.699 3.133.699C1.789.7.7 1.787.7 3.128",
    mask: "url(#b1pi9uv6zf)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18 6.5)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "tfblz9ql9h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#6n75757eeg"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F4333F",
    d: "M.677 3.07c0 1.34 1.089 2.428 2.433 2.428 1.343 0 2.433-1.088 2.433-2.429 0-1.34-1.09-2.427-2.433-2.427C1.766.642.677 1.728.677 3.07",
    mask: "url(#tfblz9ql9h)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#EDE3E3",
    d: "M14.465 13.068h-1.709v-1.705c0-.594-.483-1.076-1.079-1.075-.596 0-1.078.482-1.078 1.076v1.705H8.892c-.596 0-1.078.483-1.078 1.077s.483 1.076 1.079 1.075H10.6v1.705c0 .595.484 1.076 1.08 1.076.596 0 1.078-.482 1.078-1.077v-1.704h1.708c.596-.001 1.078-.483 1.078-1.078 0-.594-.483-1.075-1.079-1.075"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVeterinarian);
export default __webpack_public_path__ + "static/media/veterinarian.e5efed65550dc3e1fbff25c19eacd49e.svg";
export { ForwardRef as ReactComponent };